import { handleChatMessage } from './chat-message';
import { handleChangeCurrentAgent } from './change-current-agent';
import { handleClientFieldsChanged } from './client-fields-changed';
import { handleFormShown } from './form-shown';
import { handleLeadCreated } from './lead-created';

export const dialogsHandlers = () => [
  handleChatMessage(),
  handleChangeCurrentAgent(),
  handleClientFieldsChanged(),
  handleFormShown(),
  handleLeadCreated(),
];
